module.exports = __webpack_public_path__ + "img/11-preview.509683aa.webp";